import * as React from "react";
const SvgFiRrShieldXmark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18.573 2.126 12.315.051a1 1 0 0 0-.63 0L5.426 2.126A4.99 4.99 0 0 0 2 6.872v5.171c0 6.562 7.005 10.576 9.153 11.65 0 0 .519.307.85.307s.791-.24.791-.24c2.16-.869 9.207-4.281 9.207-11.717V6.872a4.99 4.99 0 0 0-3.428-4.746M20 12.043c0 6.182-6.088 9.111-7.953 9.861C10.159 20.96 4 17.459 4 12.043V6.872c0-1.295.826-2.439 2.056-2.848L12 2.053l5.944 1.971A3 3 0 0 1 20 6.872zM15.707 9.2l-2.293 2.293 2.293 2.293a.999.999 0 1 1-1.414 1.414L12 12.907 9.707 15.2a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.293-2.293L8.293 9.2a.999.999 0 1 1 1.414-1.414L12 10.079l2.293-2.293A.999.999 0 1 1 15.707 9.2"
    />
  </svg>
);
export default SvgFiRrShieldXmark;
